import type { ForgeUIAnalyticsContext } from '@atlassian/xen-editor-provider';
import { ProductEnvironment } from '@atlassian/xen-editor-provider';
import { fg } from '@confluence/feature-gating';

// Refer to ForgeUIExtensionDataType in @confluence/forge-ui for typing of this object
// Couldn't directly import it & type the return because of circular dependency issues
export const createForgeMacroExtensionData = ({
	contentId,
	contentType,
	spaceKey,
	spaceId,
	isLivePage,
	templateId,
}: {
	contentId: string;
	contentType: string | undefined;
	spaceKey: string;
	isLivePage: boolean;
	spaceId?: string;
	templateId?: string;
}) => ({
	type: 'macro',
	content: {
		id: contentId,
		type: contentType,
		subtype: isLivePage ? 'live' : null,
	},
	space: {
		key: spaceKey,
		id: spaceId,
	},
	...(templateId && fg('forge-ui-includes-template-editor-extension-data')
		? { template: { id: templateId } }
		: {}),
});

export function createForgeUIAnalyticsContext({
	objectId,
	objectType,
	containerId,
	containerType,
}: {
	objectId: string;
	objectType: 'page' | 'blogpost' | null;
	containerId: string | null;
	containerType: 'space';
}): ForgeUIAnalyticsContext {
	return {
		objectId,
		objectType: objectType || undefined,
		containerId: containerId || undefined,
		containerType,
	};
}

export function environmentToForgeProductEnvironment(environment: string) {
	return (
		// In dev, proxying to a site will give that site's environment,
		// which is not what we want
		window.location.hostname === 'localhost'
			? ProductEnvironment.DEVELOPMENT
			: environment === 'STAGING'
				? ProductEnvironment.STAGING
				: environment === 'PRODUCTION'
					? ProductEnvironment.PRODUCTION
					: ProductEnvironment.DEVELOPMENT
	);
}
